module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/35178aa388d5f1ca49b5780a76b97995.png";